// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__REmKF","footer":"ChangeClinic_footer__2oyHy"};